import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { isLoggedIn, isAdmin } from "./../util";
import { logoutAction } from "../actions/index";
import { Segment } from "semantic-ui-react";
import {
  Menu, 
  Dropdown,
  Tab,
} from "semantic-ui-react";
import Users from "../components/ControlPanelComponents/Users.jsx";
import Templates from "../components/ControlPanelComponents/Templates.jsx";
import matrix from "../Images/matrix-logo.png";
import Dashboard from "../components/ControlPanelComponents/Dashboard.jsx";
import RawFileProcess from "../components/ControlPanelComponents/RawFileProcess.jsx";
import Automation from "../components/ControlPanelComponents/Corporate Automation/Automation.jsx";
import LatAutomation from "../components/ControlPanelComponents/LatIncentives/Automation.jsx";
import AdhocAutomation from "../components/ControlPanelComponents/Adhoc Reports/Automation.jsx";
import BranchMapping from "./ControlPanelComponents/BranchMapping.jsx";
import PSRReport from "../components/ControlPanelComponents/PSR Reports/PSRReport.jsx";
import WSQPS from "../components/ControlPanelComponents/WS QPS/WholesaleQPS.jsx"

class ControlPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sideBarVisible: true,
    };
  }


  logout = () => {
    this.props.logout();
    this.props.history.push("/login");
  };

  componentWillMount() {
    if (!isLoggedIn(this.props.auth)) {
      this.logout()
    }
    if (!isAdmin(this.props.auth)) {
      this.props.history.push(`/`);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!isLoggedIn(nextProps.auth)) {
      this.props.history.push(`/login`);
      return false;
    }
    if (!isAdmin(this.props.auth)) {
      this.props.history.push(`/`);
      return false;
    }   
    return true;
  }

  toggleSidebar = () => {
    this.setState({ sideBarVisible: !this.state.sideBarVisible });
  };

  openHome = () => {
    this.props.history.push(`/home`);
  };
  render() {
    const admin = [
      {
        menuItem: { key: "users", icon: "users", content: "Distributors" },
        render: () => (
          <Tab.Pane>
            <Users />
          </Tab.Pane>
        ),
      },
      {
        menuItem: { key: "master", icon: "file excel outline", content: "Templates" },
        render: () => (
          <Tab.Pane>
            <Templates />
          </Tab.Pane>
        ),
      },   
      {
        menuItem: { key: "dashboard", icon: "dashboard", content: "Dashboards" },
        render: () => (
          <Tab.Pane>
           <Dashboard />
          </Tab.Pane>
        ),
      },
      {
        menuItem: { key: "rawFileProcess", icon: "hourglass start", content: "Raw File Processing" },
        render: () => (
          <Tab.Pane>
           <RawFileProcess />
          </Tab.Pane>
        ),
      },
      {
        menuItem: { key: "automation", icon: "sync alternate", content: "Corporate Automation" },
        render: () => (
          <Tab.Pane>
           <Automation />
          </Tab.Pane>
        ),
      },
      {
        menuItem: { key: "automation", icon: "sync alternate", content: "LAT Incentives" },
        render: () => (
          <Tab.Pane>
           <LatAutomation />
          </Tab.Pane>
        ),
      },
      {
        menuItem: { key: "automation", icon: "sync alternate", content: "One Off Displays" },
        render: () => (
          <Tab.Pane>
           <AdhocAutomation />
          </Tab.Pane>
        ),
      },
      {
        menuItem: { key: "excel", icon: "file excel", content: "PSR Reports" },
        render: () => (
          <Tab.Pane>
           <PSRReport />
          </Tab.Pane>
        ),
      },
      {
        menuItem: { key: "excel", icon: "file excel", content: "Wholesale QPS" },
        render: () => (
          <Tab.Pane>
           <WSQPS />
          </Tab.Pane>
        ),
      }

    ];
    const photoAuditTeam = [
      {
        menuItem: { key: "rawFileProcess", icon: "hourglass start", content: "Raw File Processing" },
        render: () => (
          <Tab.Pane>
           <RawFileProcess />
          </Tab.Pane>
        ),
      },
    ]

    const HFSTeam = [
      {
        menuItem: { key: "dashboard", icon: "dashboard", content: "Dashboards" },
        render: () => (
          <Tab.Pane>
           <Dashboard />
          </Tab.Pane>
        ),
      }
    ]

    return (
      <div style={{ height: "100%" }}>
        <Segment raised style={{ backgroundColor: "white", height: 60 }}>
          <div style={{ display: "inline-block" }}>
            <img
              style={{
                height: 60,
                marginTop: -13,
                float: "left",
              }}
              src={matrix}
            />
          </div>
          <Menu.Menu
            style={{ display: "inline", float: "right", marginTop: 8,marginRight: 50, }}
          >
            {(this.props.auth.userName == 'Admin' || this.props.auth.userName == 'MatrixLogin') &&
            <Dropdown pointing text={this.props.auth.location}>
              <Dropdown.Menu>
                
                   <Dropdown.Item onClick={this.openHome}>Home</Dropdown.Item>
                   <Dropdown.Item onClick={this.logout}>Logout</Dropdown.Item>
            
               
              </Dropdown.Menu>
            </Dropdown>
  }
    {this.props.auth.userName == 'PhotoAudit' &&
            <Dropdown pointing text={this.props.auth.location}>
              <Dropdown.Menu>

                   <Dropdown.Item onClick={this.logout}>Logout</Dropdown.Item>
            
               
              </Dropdown.Menu>
            </Dropdown>
  }
  {this.props.auth.userName == 'HFSTeam' &&
            <Dropdown pointing text={this.props.auth.location}>
              <Dropdown.Menu>

                   <Dropdown.Item onClick={this.logout}>Logout</Dropdown.Item>
            
               
              </Dropdown.Menu>
            </Dropdown>
  }
          </Menu.Menu>
        </Segment>
        {console.log(this.props.auth.userName,'this.props.auth.userName')}
        {(this.props.auth.userName === "Admin" || this.props.auth.userName === "MatrixLogin") &&  <Tab panes={admin} />}      
        {this.props.auth.userName === "PhotoAudit" && <Tab panes={photoAuditTeam} />}  
        {this.props.auth.userName === "HFSTeam" && <Tab panes={HFSTeam} />}  
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    vendor: state.vendor,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      logout: logoutAction,
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ControlPanel)
);
